<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{title}}</h1>
      <h2 class="subtitle">{{subtitle}}</h2>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: String,
    subtitle: String
  }
};
</script>